import React from 'react'
import PropTypes from 'prop-types'
import { message } from 'antd'
import WrappedModal from '@/components/WrappedModal'
import { markMonitoringLogFalsePositive } from '@/service/alerts'
import MarkMonitoringLogFalsePositiveForm from './MarkMonitoringLogFalsePositiveForm'

function resolveMarkFalsePositiveError (err) {
  if (typeof err === 'string' && err) return err
  return (
    err?.response?.data?.msg ||
    err?.response?.data?.message ||
    err?.msg ||
    err?.message ||
    '标记误判失败'
  )
}

class MarkMonitoringLogFalsePositiveModal extends React.Component {
  static propTypes = {
    title: PropTypes.string,
    width: PropTypes.number,
    baseProps: PropTypes.object,
    onSuccess: PropTypes.func,
    children: PropTypes.node
  }

  static defaultProps = {
    title: '标成误报',
    width: 480,
    baseProps: {}
  }

  handleOk = async (form) => {
    const { baseProps, onSuccess } = this.props
    const { record } = baseProps || {}
    const id = record?.id
    if (id == null || id === '') {
      message.error('缺少记录 id，无法标记误判')
      throw new Error('缺少记录 id')
    }
    try {
      const fields = await form.current.validateFields()
      await markMonitoringLogFalsePositive({
        id,
        falsePositiveReason: fields.falsePositiveReason
      })
      message.success('已标成误报')
      if (typeof onSuccess === 'function') onSuccess()
    } catch (err) {
      if (err?.errorFields) throw err
      message.error(resolveMarkFalsePositiveError(err))
      throw err
    }
  }

  render () {
    const { children, baseProps, title, width } = this.props
    const bp = baseProps || {}
    return (
      <WrappedModal
        children={children}
        baseComponent={<MarkMonitoringLogFalsePositiveForm baseProps={bp} />}
        baseProps={{ ...bp }}
        title={title}
        width={width}
        okText="确认"
        okType="danger"
        onOk={this.handleOk}
      />
    )
  }
}

export default MarkMonitoringLogFalsePositiveModal
